export default __webpack_public_path__ + "static/media/i_manos.cb7b39b2.svg";